/** The approved Create Quote worksheet proportions. Weights are normalized
 * over the columns actually shown, so optional columns do not widen a table. */
export const quoteWorksheetWeights = {
  date: [164, 148], quantity: [38, 32], dress: [70, 54], area: [125, 110],
  position: [150, 112], tools: [70, 54], 'call-time': [196, 172], notes: [240, 133],
  'rate-type': [90, 66], 'call-type': [105, 80], meal: [95, 76], rate: [70, 60],
  st: [40, 30], ot: [40, 30], dt: [40, 30], 'per-diem': [70, 60],
  misc: [70, 60], total: [88, 72]
} as const;

export type QuoteWorksheetColumn = keyof typeof quoteWorksheetWeights;

export function quoteWorksheetColumnPlan(columns: QuoteWorksheetColumn[]) {
  const standardTotal = columns.reduce((sum, column) => sum + quoteWorksheetWeights[column][0], 0);
  const compactTotal = columns.reduce((sum, column) => sum + quoteWorksheetWeights[column][1], 0);
  return columns.map(name => ({
    name,
    standardWidth: `${quoteWorksheetWeights[name][0] / standardTotal * 100}%`,
    compactWidth: `${quoteWorksheetWeights[name][1] / compactTotal * 100}%`
  }));
}
